import React from 'react';

const APPS = [
  {
    featured: true,
    category: 'Strategy',
    name: 'Boardroom Counterfactuals',
    desc: 'Run a pending decision against historically analogous cases before you make it — see how similar choices played out under comparable constraints.',
    status: 'live',
  },
  {
    category: 'Capital Allocation',
    name: 'Portfolio Forks',
    desc: 'Model how a single allocation decision reshapes the options available in the following quarter.',
    status: 'live',
  },
  {
    category: 'Policy',
    name: 'Legislative Pathways',
    desc: 'Compare a proposed policy against its nearest historical precedent and its counterfactual alternatives.',
    status: 'live',
  },
  {
    category: 'Science',
    name: 'Research Forks',
    desc: 'Map how a methodological choice narrows or widens the discoveries reachable downstream.',
    status: 'pending',
  },
  { empty: true },
];

export default function IvoriMarketplaceGrid({ gridRef }) {
  return (
    <div className="ivori-landing-app-grid" ref={gridRef}>
      {APPS.map((a, i) => {
        if (a.empty) {
          return (
            <div className="ivori-landing-app-tile ivori-landing-empty" key="empty-tile">
              <div className="ivori-landing-app-category">More apps coming</div>
            </div>
          );
        }
        const statusClass =
          a.status === 'pending' ? 'ivori-landing-app-status ivori-landing-pending' : 'ivori-landing-app-status';
        const statusLabel = a.status === 'pending' ? 'In development' : 'Preview';
        return (
          <div
            className={`ivori-landing-app-tile${a.featured ? ' ivori-landing-featured' : ''}`}
            key={a.name}
          >
            <div className="ivori-landing-app-category">{a.category}</div>
            <div className="ivori-landing-app-name">{a.name}</div>
            <p className="ivori-landing-app-desc">{a.desc}</p>
            <div className={statusClass}>
              <span className="ivori-landing-dot" />
              {statusLabel}
            </div>
          </div>
        );
      })}
    </div>
  );
}
